import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BasePricingService } from "shared/cubiq-services/lookup/pricing/impl/BasePricingService";
import { OrdersTableMode } from "shared/cubiq-services/model/OrdersTableMode";
import { ICellRendererAngularComp } from "@bfx/ag-grid-angular";
import { PricingService } from "shared/cubiq-services";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "fwdPtsRenderer",
  templateUrl: "./html/FwdPtsRenderer.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FwdPtsRenderer implements ICellRendererAngularComp {
  public fwdPts: string;
  public showStrike: boolean;

  constructor(
    public cd: ChangeDetectorRef,
    protected myBasePricingService: BasePricingService,
  ) {}

  // called on init
  agInit(params: ICellRendererParams): void {
    this.doVal(params);
  }

  doVal(params: ICellRendererParams): boolean {
    let changed: boolean = false;
    let fwdPts = PricingService.clearStrikeThroughString(params.getValue());
    let showStrike: boolean = false;

    if (params.data?.isLadderRate || params.data?.isLadderAggregate) {
      if (this.fwdPts !== "") {
        fwdPts = "";
        changed = true;
      }
    } else if (fwdPts == null && this.fwdPts === "-") {
      return false;
    } else if (fwdPts == null) {
      fwdPts = "-";
    } else if (
      params.data.product != CubiqTS.Product.SPT &&
      params.data.adjustedSettleTenor != CubiqTS.Tenor.SPOT &&
      this.myBasePricingService
    ) {
      let order: CubiqTS.OrderDataImpl = params.data;
      let pair: CubiqTS.CurrencyPairImpl =
        this.myBasePricingService.ccyPairLookupService.getCcyPair(
          order.baseCode,
          order.nonBaseCode,
        );

      if (
        (params.context.mode == OrdersTableMode.NDF_BASE ||
          params.context.mode == OrdersTableMode.NDF_DEALT) &&
        pair.ndfEnabledFg
      ) {
        showStrike = this.myBasePricingService.isStrikethroughFwdPtsNdfTracking(params.data);
      } else {
        showStrike = this.myBasePricingService.isStrikethroughFwdPts(params.data);
      }
    } else {
      showStrike = false;
    }

    if (this.fwdPts != fwdPts) {
      changed = true;
      this.fwdPts = fwdPts;
    }

    if (this.showStrike != showStrike) {
      changed = true;
      this.showStrike = showStrike;
    }

    if (changed) {
      if (params.eGridCell != null) {
        if (this.showStrike) params.eGridCell.title = "--- " + this.fwdPts + " ---";
        else params.eGridCell.title = this.fwdPts;
      }
    }
    return changed;
  }

  // called when the cell is refreshed
  refresh(params: any): boolean {
    if (this.doVal(params)) {
      this.cd.markForCheck();
    }

    return true;
  }
}
